import { useListContext } from 'react-admin';

import { BOResourceAll } from '@Common/types/bo_external/resources';

import {
  ServerExportButton,
  useExportNeedsConfirmation,
} from '@sh4res/bo-common/components/ServerExportButton';
import { useResourceBasePath } from '@sh4res/bo-common/hooks';

/**
 * Exports the operations the list selects, asking for a confirmation in the internal BO when no
 * filter is applied (as exporting might take a lot of time)
 */
export const ExportButtonWithConfirmation = ({ testId }: { testId: string }) => {
  const { filter, filterValues, sort, total } = useListContext();
  const resource = `${useResourceBasePath()}individual_operations` as BOResourceAll;
  const needsConfirmation = useExportNeedsConfirmation();

  return (
    <ServerExportButton
      resource={resource}
      disabled={total === 0}
      needsConfirmation={needsConfirmation}
      getBody={() => ({
        kind: 'individual_operations',
        query: {
          // The tab's status filter is the list's permanent filter
          filter: JSON.stringify({ ...filterValues, ...filter }),
          sort: JSON.stringify([sort.field, sort.order]),
        },
      })}
      data-testid={`${testId}_ExportButton`}
    />
  );
};
